import { changeOf } from "../../shared/chartMath";

export type Quadrant =
  | "betterBoth"
  | "trade"
  | "gamble"
  | "dominated"
  | "unchanged";

// split-bar order, good → bad, then the cases settling left as they were
export const QUADRANTS: readonly Quadrant[] = [
  "betterBoth",
  "trade",
  "gamble",
  "dominated",
  "unchanged",
];

/**
 * Which group a settled case falls in — the one classification behind the
 * dots' colours and the split bar's counts. Each axis is read the way the
 * tooltip words it (see {@link changeOf}), so a case the tooltip calls
 * unchanged is never counted as better or worse on that axis.
 *
 * A case unchanged on one axis traded nothing, so the other axis alone decides
 * it. Only a change for the better on one axis and for the worse on the other
 * is a trade or a gamble, and a case unchanged on both is neither good nor bad.
 */
export function quadrantOf({
  exposureRemoved,
  evChange,
}: {
  exposureRemoved: number;
  evChange: number;
}): Quadrant {
  const reward = changeOf(evChange);
  const risk = changeOf(exposureRemoved);
  if (reward === "unchanged" && risk === "unchanged") return "unchanged";
  if (reward !== "worse" && risk !== "worse") return "betterBoth";
  if (reward !== "better" && risk !== "better") return "dominated";
  // gave up expected value to cut risk: the rational trade
  if (reward === "worse") return "trade";
  // kept more upside at the cost of more exposure
  return "gamble";
}
